import { componentName, UserAttributeClass } from './UserAttributeClass';
import '@descope-ui/descope-text';
import '@descope-ui/descope-button';
import '@descope-ui/descope-badge';
import '@descope-ui/descope-icon';

customElements.define(componentName, UserAttributeClass);

export { UserAttributeClass, componentName };
